module.exports = __webpack_public_path__ + "img/canada-transport-accidents-male.75e40f6b.png";